import axios from 'axios'
import { config } from '@/config/environment'

/**
 * JWT-only client for the **Apps SDK Builder**, reached through the main `api`
 * gateway at `/apps-sdk/*` (api proxies to the Builder on seraph) — clients never
 * talk to the backend or the DB directly. Like `adminApi`, it sends ONLY the
 * Authorization header (no X-Organization-Slug); the Builder validates the EDGE JWT
 * + the `admin` role itself. Admin-only, never customer-facing.
 */
export const appsSdkApi = axios.create({ baseURL: `${config.apiBaseUrl}/apps-sdk` })

appsSdkApi.interceptors.request.use((cfg) => {
  const authToken = localStorage.getItem('authToken')
  cfg.headers = cfg.headers || {}
  if (authToken) {
    cfg.headers.Authorization = authToken.startsWith('Bearer ') ? authToken : `Bearer ${authToken}`
  }
  return cfg
})
